import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { Classificazione } from '../../../models/classificazione';
import { ClassificazioneSezione } from '../../../models/sezioni/classificazione-sezione';
import { ClassificazionePraticaUpdateComponent } from './classificazione-pratica-update.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [classificazione-mod-update]',
  templateUrl: 'classificazione-mod-update.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ClassificazioneModUpdateComponent {
  @Input() idFormPratica: string;
  @Output() onReturn: EventEmitter<ClassificazioneSezione> = new EventEmitter<ClassificazioneSezione>();
  @ViewChild('formClassificazioneUpdate') formClassificazioneUpdate: ClassificazionePraticaUpdateComponent;

  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();

  inizializza(idSezione: string, urlUpdateClassificazione: string, classificazione: Classificazione, idPratica: string, listaClassificazioni: Classificazione[]) {
    this.formClassificazioneUpdate.inizializza(idSezione, urlUpdateClassificazione, classificazione, idPratica, listaClassificazioni);
    openModal('modalClassificazioneUpdate');
  }

  createForm() {
    this.formClassificazioneUpdate.createForm();
  }

  reset() {
    this.formClassificazioneUpdate.createForm();
  }

  manageModal(classificazioneSezione: ClassificazioneSezione) {
      closeModal('modalClassificazioneUpdate');
      if (classificazioneSezione) {
        this.onReturn.emit(classificazioneSezione);
      }
  }
}
